import { NOTIFICATION_SESSION_STORAGE_KEY } from "./constants";
import global from "global";

const clearNotificationsStorage = () => {
  try {
    global.sessionStorage.removeItem(NOTIFICATION_SESSION_STORAGE_KEY);
  } catch (_) {
    return;
  }
};

export default clearNotificationsStorage;
